import React, { Fragment, useCallback, useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchema } from "../../../conf/people";
import { Loading } from "../../../components/common";
import { useDispatch, useSelector } from "react-redux";
import Request from "../../../core/requests";
import SideDialogComponent from "components/dialog/SideDialog.component";
import PeopleCounterForm from "forms/people-counter/PeopleCounterForm.component";
import { openSnackbar } from "store/slices/snackbar";
import { refreshToken, logout } from "store/user.store";
import { useTranslation } from "react-i18next";

const UpdatePeopleCounterContainer = ({
  data,
  open,
  handleCloseDialog = () => { },
  isSuperUser,
  setSuccess = () => { },
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const {
    token,
    refresh_token,
    loading: loadingRefresh,
    user
  } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [dataSubmit, setDataSubmit] = useState(null);
  //const [stationEdit, setStationEdit] = useState(null);
  const [idDelete, setIdDelete] = useState(null)
  const { handleSubmit, control, formState, setValue } = useForm({
    resolver: yupResolver(ValidationSchema),
    defaultValues: {
      pcounter_id: "",
    },
  });

  const updateForm = useCallback(() => {
    if (data) {
      setValue("pcounter_id", data?.peopleCounterID);
    }
    // eslint-disable-next-line
  }, [data]);

  const handleDelete = useCallback(
    () => {
      if (isSuperUser && !loadingRefresh) {
        //setUpdate(null);
        setIdDelete(data);

        // Request.stations
        //   .deleteSensorPCount({
        //     token: token,
        //     ...data,
        //   })
        //   .then((resp) => {
        //     onSuccess(resp);
        //   })
        //   .catch((error) => onError(error, data));
      }
    },
    // eslint-disable-next-line
    [isSuperUser, token, loadingRefresh, data]
  );

  const onSubmit = useCallback(
    (values) => {
      if (isSuperUser) {
        Request.stations
          .updatePeopleCounterId(
            {
              id: data?.stationId,
              token: token,
            },
            { pcounter_id: values.pcounter_id }
          )
          .then((resp) => {
            onSuccess(resp);
          })
          .catch((error) => onError(error, values,));
      }
    },
    // eslint-disable-next-line
    [token, isSuperUser]
  );

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error, data) => {
      setLoading(false);
      setDataSubmit(data)
      if (isFirstRefresh) {
        setLoading(false);
        if (error?.response?.status === 403) {
          dispatch(logout());
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    if (data?.stationId && data?.peopleCounterID) {
      setLoading(true);
      Request.stations
        .getPCStation({
          id: data.stationId,
          pcounter_id: data.peopleCounterID,
          token: token,
        })
        .then((resp) => {
          setLoading(false);
          // setStationEdit(resp);
        })
        .catch((error) => onError(error, ""));
    }
    // eslint-disable-next-line
  }, [data, token]);



  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error?.response?.data?.message
          ? error.response.data?.message
          : "Errore",
        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateForm();
    // eslint-disable-next-line
  }, [data]);

  const onSuccess = useCallback(
    (resp) => {
      setSuccess(resp);
      setLoading(false);
      setIdDelete(null)
      setIsFirstRefresh(true)
      dispatch(
        openSnackbar({
          open: true,
          message: resp.message,
          variant: "alert",
          alert: {
            color: resp.status,
          },
          close: false,
        })
      );
    },
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    if (dataSubmit && !isFirstRefresh && !loadingRefresh) {
      onSubmit(dataSubmit);
    }
    // eslint-disable-next-line
  }, [isFirstRefresh, loadingRefresh, dataSubmit, refresh_token]);

  useEffect(() => {
    if (!isFirstRefresh && idDelete && !loadingRefresh) {
      handleDelete(idDelete);
    }
    // eslint-disable-next-line
  }, [isFirstRefresh, idDelete, loadingRefresh]);

  return (
    <Fragment>
      {loading && <Loading />}
      <SideDialogComponent open={open} handleCloseDialog={handleCloseDialog}>
        <PeopleCounterForm
          errors={formState.errors}
          control={control}
          handleSubmit={handleSubmit(onSubmit)}
          labelButton={t('Edit')}
          title={t('Edit People Counter Sensor ID')}
          handleCloseDialog={handleCloseDialog}
        />
      </SideDialogComponent>
    </Fragment>
  );
};

export default UpdatePeopleCounterContainer;
